import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";

const vobDocuments = {
    namespaced: true,
    state: {
        dataReceive: {},
        chosenType: null,
        dataLoading: false,
        content: null,
        docGenerating: false,
        docSending: false,
        generatedDocId: null,
        vobSendIsFetching: [],
    },
    mutations: {
        GET_VOB_DOCUMENT_FAILURE(state, error) {
            console.log(error);  
        },
        GET_VOB_DOCUMENT_SUCCESS(state, response) {
            state.dataReceive = response.data.data;
        },
        SAVE_VOB_DOCUMENT_FAILURE(state, error) {
            if (error.response.data.errors.type && error.response.data.errors.type[0] === 'diskLimitExceeded') {
                eventBus.$emit('projectDiskLimitExceeded', error.response.data.errors);
            } else {
                console.log(error);
            } 
        },
        SAVE_VOB_DOCUMENT_SUCCESS(state, response) {
            eventBus.$emit('saveVobDocumentSuccess', response.data)
            state.generatedDoc = response.data.id;
        },
        SEND_VOB_DOCUMENT_FAILURE(state, error) {
            if (error.response.data.errors.type && error.response.data.errors.type[0] === 'diskLimitExceeded') {
                eventBus.$emit('projectDiskLimitExceeded', error.response.data.errors);
            } else {
                console.log(error);
            }     
        },
        SEND_VOB_DOCUMENT_SUCCESS(state, response) {
            eventBus.$emit('sendVobDocumentSuccess', response.data)
            state.generatedDoc = response.data.id;
        },
        UPDATE_CHOSEN_TYPE(state, value) {
            state.chosenType = value;
        },
        PREPARE_CONTENT(state, value) {
            state.content = value;
        }
    },
    actions: {
        getVobDocumentRequest({dispatch, state}) {
            const urlParams = new URLSearchParams(window.location.search);

            let promise = sendRequest("get", config.baseURLApi + "/get-vob-document/" + urlParams.get("id") + '/' + state.chosenType);
            state.dataLoading = true;
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetVobDocument", result[1]);
                } else {
                    dispatch("failureGetVobDocument", result[1]);
                }
                state.dataLoading = false;
            });
        },
        saveVobDocumentRequest({dispatch, state}, payload = null) {
            const urlParams = new URLSearchParams(window.location.search);
            let data = {
                'content': state.content,
            }
            if(payload !== null) {
                data = {
                    'content': state.content,
                    'send': payload.creds.sendEmail === undefined ? false : payload.creds.sendEmail,
                    'email': payload.creds.email === undefined ? null : payload.creds.email,
                }
            }
            let promise = sendRequest("post", config.baseURLApi + "/save-vob-document/" + urlParams.get("id") + '/' + state.chosenType, {}, data);
            payload === null ? state.docGenerating = true : state.docSending = true;
            state.vobSendIsFetching.push(data.email);
            promise.then(function(result) {
                if(result[0] === "success") {
                    payload === null ? dispatch("successSaveVobDocument", result[1]) : dispatch("successSendVobDocument", result[1]);
                } else {
                    payload === null ? dispatch("failureSaveVobDocument", result[1]) : dispatch("failureSendVobDocument", result[1]);
                }
                payload === null ? state.docGenerating = false : state.docSending = false;
                state.vobSendIsFetching.splice(state.vobSendIsFetching.indexOf(data.email), 1);

            });
        },

        successGetVobDocument({ commit }, response) {
            commit("GET_VOB_DOCUMENT_SUCCESS", response);
        },
        failureGetVobDocument({ commit }, error) {
            commit("GET_VOB_DOCUMENT_FAILURE", error);
        },
        successSaveVobDocument({ commit }, response) {
            commit("SAVE_VOB_DOCUMENT_SUCCESS", response);
        },
        failureSaveVobDocument({ commit }, error) {
            commit("SAVE_VOB_DOCUMENT_FAILURE", error);
        },
        successSendVobDocument({ commit }, response) {
            commit("SEND_VOB_DOCUMENT_SUCCESS", response);
        },
        failureSendVobDocument({ commit }, error) {
            commit("SEND_VOB_DOCUMENT_FAILURE", error);
        },
        updateChosenType: function({ commit }, value) {
            commit("UPDATE_CHOSEN_TYPE", value);
        },
        prepareContent: function({commit}, value) {
            commit("PREPARE_CONTENT", value);
        }
    }
}

export default vobDocuments;